import axios from "@/utils/axiosHelper";

// 初始化数据
export const onGetInitDataAPI = (params) => {
  return axios(
    { url: `/ares/year/init?time=${Date.now()}`, method: "GET", params },
    { interceptResultCode: false }
  );
};

// 建筑升级
export const buildingUp = (params) => {
  return axios(
    { url: "/ares/year/up", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取收益
export const income = (params) => {
  return axios(
    { url: "/ares/year/income", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 抽奖
export const draw = (params) => {
  return axios(
    { url: "/ares/year/draw", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 抽奖公告
export const drawBigInfo = (params) => {
  return axios(
    { url: "/ares/year/notify", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 完成待办任务
export const finishTask = (params) => {
  return axios(
    { url: "/ares/year/task", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取任务奖励
export const getTaskReward = (params) => {
  return axios(
    { url: "/ares/year/get/task", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 助力
export const invite = (params) => {
  return axios(
    { url: "/ares/year/invite", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取抽奖累计奖励,cumulative_id
export const getCumulative = (params) => {
  return axios(
    { url: "/ares/year/cumulative", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取故事奖励,story_id
export const getStory = (params) => {
  return axios(
    { url: "/ares/year/story", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 填写地址,province,city,country,address,phone,name
export const submitAddress = (params) => {
  return axios(
    { url: "/ares/year/address", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 注销
export const onLogoutAPI = (params) => {
  return axios(
    { url: "/game/my/disable", method: "POST", params },
    { interceptResultCode: false }
  );
};

export const downloadApps = (params) => {
  return axios(
    { url: "/jump/download/url", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/ares/anniversary/api.js